// src/routes/RequireAuth.jsx
import { Navigate, useLocation } from "react-router-dom";
import { checkIfAuthenticated } from "../utils/utils";
import { useEffect, useRef, useState } from "react";
import axios from "../config/axiosInstance";
import DrawerLoading from "../components/DrawerLoading";
import { ONBOARDING } from "../config/apiConfig";

const REQUIRE_AUTH_POLL_MS = 300000; // 5min

const RequireAuth = ({ children }) => {
  const location = useLocation();

  // estados
  const [isAuthenticated, setIsAuthenticated] = useState(
    checkIfAuthenticated()
  );
  const [onbLoading, setOnbLoading] = useState(true);
  const [onbCompleted, setOnbCompleted] = useState(null);
  const fetchedRef = useRef(false); // evita chamadas duplicadas em StrictMode

  // revalida sessão periodicamente (hook sempre registrado)
  useEffect(() => {
    const interval = setInterval(() => {
      const authStatus = checkIfAuthenticated();
      if (authStatus !== isAuthenticated) setIsAuthenticated(authStatus);
    }, REQUIRE_AUTH_POLL_MS);
    return () => clearInterval(interval);
  }, [isAuthenticated]);

  // busca status do onboarding quando autenticado (hook sempre registrado)
  useEffect(() => {
    // se não autenticado, não chama API e termina loading do onboarding
    if (!isAuthenticated) {
      setOnbLoading(false);
      setOnbCompleted(null);
      return;
    }
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    let mounted = true;
    (async () => {
      try {
        setOnbLoading(true);
        const { data } = await axios.get(ONBOARDING.GET); // '/api/onboarding/status'
        if (!mounted) return;
        setOnbCompleted(!!data?.onbCompleted);
      } catch (err) {
        if (!mounted) return;
        const status = err?.response?.status;
        // 401/403 → força login
        if (status === 401 || status === 403) {
          setIsAuthenticated(false);
          setOnbCompleted(null);
        } else {
          // falha genérica → trate como não concluído para exibir /onboarding
          setOnbCompleted(false);
        }
      } finally {
        if (mounted) setOnbLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [isAuthenticated]);

  // ---- só agora os returns (depois dos hooks) ----

  // não autenticado → login
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // carregando status do onboarding
  if (onbLoading) return <DrawerLoading />;

  // caso normal
  return children;
};

export default RequireAuth;
